import { t, tn } from '@kadice/shared';
import { voiceSupported, type Voice } from '../voice';

/** The game's voice chat controls, after Send in the chat window (buttons, not submits): Voice (join), or Mute/Unmute and Leave Voice with who's in. */
export function VoiceBar({ voice }: { voice: Voice }) {
  if (!voiceSupported()) return null;
  const count = voice.members.length;
  return (
    <span className="voice-bar">
      {count > 0 && <span className="muted small">{tn('voice.count', count)}</span>}
      {voice.joined ? (
        <>
          <button type="button" onClick={voice.toggleMute} aria-pressed={voice.muted}>
            {voice.muted ? `🔇 ${t('voice.unmute')}` : `🎙 ${t('voice.mute')}`}
          </button>
          <button type="button" onClick={voice.leave}>
            {t('voice.leave')}
          </button>
        </>
      ) : (
        <button type="button" onClick={voice.join} disabled={voice.joining} title={t('voice.joinHint')}>
          {voice.joining ? t('voice.joining') : `🎙 ${t('voice.join')}`}
        </button>
      )}
    </span>
  );
}
